module.exports = {"title":"user_signup_form","type":"object","properties":{"username":{"type":"string","pattern":"(?=^.{2,16}$)^[a-zA-Z0-9][a-zA-Z0-9]*[._]?[a-zA-Z0-9]*$"},"email":{"type":"string","pattern":"^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$"},"password":{"type":"string","pattern":"^\\S{8,}$"},"invite_code":{"type":"string"}},"required":["username","password","email","invite_code"]}


//////////////////
// WEBPACK FOOTER
// ./src/shared/json_schemas/userSignupForm.json
// module id = 857
// module chunks = 0